/**
 * Breadcrumb labels for the authenticated header (Thai).
 *
 * Every string here is copied from an existing, already-reviewed translation elsewhere in the
 * codebase — the source key is noted per line. Nothing is newly authored. Labels the sidebar
 * already names are not repeated here at all; they resolve from `main-navigation/locales`.
 *
 * The block at the bottom has no Thai anywhere in the codebase, so it stays English by decision
 * rather than being invented.
 */

export const th = {
  // --- Quote → plan → sale journey ---
  vmi: 'VMI', // policy-in-progress:policyTypeVmi
  selectPlans: 'เลือกแผนประกัน', // plan-listing:planListingHeaderSelectPlans
  requestCustomQuote: 'ขอใบเสนอราคาแบบกำหนดเอง', // plan-listing:planListingHeaderRequestCustomQuote
  reportSale: 'รายงานการขาย', // comparison-sheet:reportSale
  sendToCustomer: 'ส่งให้ลูกค้า', // plan-listing:sendToCustomerPageTitle
  quotations: 'ใบเสนอราคา', // comparison-sheet:headerTitle
  buyInsurance: 'ซื้อประกัน', // agents/shared:actionBuyInsurance
  bikeInsurance: 'ประกันมอเตอร์ไซค์', // prequote-forms:bikePageTitle
  bikeCustomQuote: 'ขอใบเสนอราคาแบบกำหนดเอง', // prequote-forms:bikeCustomQuoteTitle

  // --- Leads / policies ---
  newLeads: 'ลีดใหม่', // voluntary-insurance:subTabNewLeads
  changeOfAgent: 'งานโอนโค้ด', // prequote-forms:coaPageTitle
  renewals: 'ต่ออายุ', // voluntary-insurance:subTabRenewals
  fullPayment: 'ชำระเต็มจำนวน', // policy-in-progress:tabFullPayment
  endorsements: 'สลักหลัง', // main-navigation:endorsement
  commissionRates: 'อัตราค่าคอมมิชชัน', // agents/shared:commissionTitle
  teams: 'ทีม', // agents/shared:teamsPageTitle
  downline: 'ดาวน์ไลน์', // agents/shared:downlinePageTitleFallback

  // --- Sale-update flows (single label each) ---
  switchPackage: 'เปลี่ยนแพ็กเกจ/ บ.ประกัน', // policy-in-progress:actionSwitchPackage
  updatePremium: 'แก้ไขเบี้ย', // policy-in-progress:actionUpdatePremium
  recordEndorsement: 'ทำคำขอใบสลักหลัง', // policy-in-progress:actionRecordEndorsement
  cancellationEndorsement: 'การยกเลิกกรมธรรม์', // policy-in-progress:ceDetailsPageTitle
  internalInformationUpdate: 'แก้ไขข้อมูลใน Sale Wizard', // policy-in-progress:actionInternalInformationUpdate

  // --- Accounting ---
  pendingPayments: 'การชำระเงินที่รอดำเนินการ', // accounting/shared:pendingPayments
  uploadTransferCsv: 'อัปโหลดไฟล์การโอน', // accounting/shared:uploadTransferCsv
  combinedPayments: 'การชำระเงินรวม', // accounting/shared:combinedPayments
  combinedEndorsement: 'การชำระเงินรวมสลักหลัง', // accounting/shared:combinedEndorsement
  uploadCsvEndorsement: 'อัปโหลดไฟล์สลักหลัง', // accounting/shared:uploadCsvEndorsement
  manualEkycTransfer: 'การโอน EKYC ด้วยตัวเอง', // accounting/shared:manualEkycTransfer
  travel: 'ประกันการเดินทาง', // accounting/shared:product_travel
  allProducts: 'สินค้าทั้งหมด', // accounting/shared:product_all_products

  // --- No Thai exists anywhere in the codebase: English by decision, not invented ---
  home: 'Home',
  affiliateDashboard: 'Affiliate Dashboard',
  customerSupport: 'Customer Support',
  opsDashboard: 'OPS Dashboard',
  shortenedUrl: 'Shortened URL',
  soaV1: 'SOA V1',
  soaResults: 'SOA Results',
  creditInvoices: 'Credit Invoices',
  inventory: 'Inventory',
  nonMotorDeclaration: 'Non-Motor Declaration',
  nonMotorPostquote: 'Non-Motor Post Quote',
  nonMotorPayment: 'Non-Motor Payment',
} as const;
